import { useEffect, useState } from "react";

const DesktopUpdateManager = () => {
  const [update, setUpdate] = useState(null);

  useEffect(() => {
    if (!window.desktopUpdates) return undefined;
    const unsubscribe = window.desktopUpdates.onStatus(setUpdate);
    window.desktopUpdates.check();
    return unsubscribe;
  }, []);

  if (!update || !["available", "downloading", "downloaded"].includes(update.status)) return null;
  const downloading = update.status === "downloading";
  const downloaded = update.status === "downloaded";
  return (
    <div style={styles.overlay} role="alert" aria-live="assertive">
      <div style={styles.card}>
        <strong style={styles.title}>{downloaded ? "Installing required update" : downloading ? "Downloading required update" : "Required update available"}</strong>
        <span style={styles.message}>{downloaded ? `BillsArthi ${update.version || ""} will restart automatically.` : downloading ? `${update.percent || 0}% downloaded. Please keep the app open.` : `BillsArthi ${update.version || ""} is required and is downloading now.`}</span>
        {downloading ? (
          <div style={styles.progressTrack}>
            <div style={{ ...styles.progressBar, width: `${Math.max(0, Math.min(100, update.percent || 0))}%` }} />
          </div>
        ) : null}
      </div>
    </div>
  );
};

const styles = {
  overlay: { position: "fixed", inset: 0, zIndex: 99999, display: "grid", placeItems: "center", padding: 24, background: "rgba(2, 20, 34, .76)", backdropFilter: "blur(4px)" },
  card: { width: "min(440px, 100%)", padding: "28px", borderRadius: 16, background: "#073b61", color: "#fff", boxShadow: "0 24px 70px rgba(0,0,0,.38)", display: "flex", flexDirection: "column", gap: 12, textAlign: "center" },
  title: { fontSize: 20 },
  message: { lineHeight: 1.5, opacity: .92 },
  progressTrack: { height: 9, marginTop: 6, overflow: "hidden", borderRadius: 999, background: "rgba(255,255,255,.2)" },
  progressBar: { height: "100%", borderRadius: 999, background: "#8ff7d5", transition: "width .2s ease" },
};

export default DesktopUpdateManager;
